import { render, staticRenderFns } from "./UiShow.vue?vue&type=template&id=6477e22a&lang=pug&"
import script from "./UiShow.vue?vue&type=script&lang=js&"
export * from "./UiShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports